import styled from 'styled-components';

export const PopoverContent = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 10px;
`;

export const PopoverActions = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 10px;
`;

export const PopoverMessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const PopoverHelp = styled.div`
  font-size: 12px;
  color: #666;
`;
